var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanduebg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 183,
    viewBox: "0 0 405 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0H385C396.046 0 405 8.9543 405 20V183H0V20Z",
    fill: "#E84141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanduebg);
export default __webpack_public_path__ + "static/media/planduebg.ae4bf9d0e48dc3408f87d3da49d731d1.svg";
export { ForwardRef as ReactComponent };